import { reactive } from "vue";
import { createLoading } from "../../../../utils/loading";

export const { isLoading, setIsLoading } = createLoading();

export const state = reactive({
    tabKey: "1"
});
